const navMain = {
  systems: 'Рішення',
  aboutUs: 'Про нас',
  blog: 'Блог',
  career: "Кар'єра",
  contact: 'Контакти',
  bpla: 'БпЛА',
  bpak: 'БпАК',
  education: 'НАВЧАННЯ ОПЕРАТОРІВ БпЛА',
}
export default navMain
